<div style="padding: 20px 22px; max-height: 90vh; display: flex; flex-direction: column;">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 10px; border-bottom: 1px solid #e5e7eb; padding-bottom: 14px; margin-bottom: 14px;">
    <mat-icon style="color: #1C593D;">person_add</mat-icon>
    <div style="flex: 1;">
      <h2 style="font-size: 1.05rem; font-weight: 800; color: #1e5a3f; margin: 0;">
        {{ data.editId ? 'Editar beneficiario' : 'Nuevo beneficiario' }}
      </h2>
      <p style="font-size: 0.76rem; color: #6b7280; margin: 2px 0 0;">
        {{ data.variantLabel }}
      </p>
    </div>
    <button type="button" (click)="cancel()" [disabled]="saving"
      style="background: transparent; border: none; cursor: pointer; color: #6b7280; padding: 4px;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Form fields -->
  <div style="flex: 1; overflow-y: auto; padding-right: 4px;">
    <div *ngFor="let field of visibleFields" style="margin-bottom: 14px;" [id]="'dlg-field-' + field.key">
      <label style="display: block; font-size: 0.82rem; color: #374151; font-weight: 600; margin-bottom: 6px;">
        {{ field.name }}
        <span *ngIf="field.min && field.type === 'text'" style="color: #9ca3af; font-weight: 500;">
          ({{ field.min }}{{ field.max ? '–' + field.max : '' }} caracteres)
        </span>
      </label>

      <input *ngIf="field.type === 'text'" type="text"
        [(ngModel)]="formValues[field.key]"
        (input)="onFieldInput(field, $event)" (blur)="onFieldBlur(field)"
        [maxlength]="field.max || null"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; text-transform: uppercase;"
        [style.border-color]="formErrors[field.key] ? '#fecaca' : '#e5e7eb'" />

      <input *ngIf="field.type === 'email'" type="email"
        [(ngModel)]="formValues[field.key]"
        (input)="onFieldInput(field, $event)" (blur)="onFieldBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box;"
        [style.border-color]="formErrors[field.key] ? '#fecaca' : '#e5e7eb'" />

      <select *ngIf="field.type === 'select'"
        [(ngModel)]="formValues[field.key]" (change)="onFieldBlur(field)" (blur)="onFieldBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; background: white;"
        [style.border-color]="formErrors[field.key] ? '#fecaca' : '#e5e7eb'">
        <option value="">— Seleccionar —</option>
        <option *ngFor="let opt of visibleOptions(field)" [value]="opt.value">{{ opt.label }}</option>
      </select>

      <input *ngIf="field.type !== 'text' && field.type !== 'email' && field.type !== 'select'"
        type="text" [(ngModel)]="formValues[field.key]"
        (input)="onFieldInput(field, $event)" (blur)="onFieldBlur(field)"
        style="width: 100%; padding: 10px 12px; border: 2px solid #e5e7eb; border-radius: 10px; font-size: 0.9rem; outline: none; box-sizing: border-box; text-transform: uppercase;"
        [placeholder]="'(tipo: ' + field.type + ')'" />

      <div *ngIf="!formErrors[field.key] && hintForField(field)"
        style="margin-top: 4px; font-size: 0.7rem; color: #9ca3af;">
        {{ hintForField(field) }}
      </div>
      <div *ngIf="formErrors[field.key]"
        style="margin-top: 4px; font-size: 0.72rem; color: #b91c1c; font-weight: 600;">
        <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle;">error_outline</mat-icon>
        {{ formErrors[field.key] }}
      </div>

      <!-- Feedback de validación contra Vita (Capa 2). Solo aparece bajo el
           field de routing (account_bank/pix_key/clabe/iban/cvu/alias) y
           solo para países donde Vita expone validate_beneficiary. -->
      <ng-container *ngIf="isRoutingField(field)">
        <div *ngIf="routingValidating"
          style="margin-top: 4px; font-size: 0.72rem; color: #6b7280; font-weight: 500; display: flex; align-items: center; gap: 4px;">
          <mat-spinner diameter="12"></mat-spinner>
          Validando con el banco...
        </div>
        <div *ngIf="!routingValidating && routingValidation?.status === 'valid'"
          style="margin-top: 4px; font-size: 0.72rem; color: #166534; font-weight: 600;">
          <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle;">check_circle</mat-icon>
          {{ routingValidation?.message }}
        </div>
        <div *ngIf="!routingValidating && routingValidation?.status === 'not_registered'"
          style="margin-top: 4px; font-size: 0.72rem; color: #b45309; font-weight: 600;">
          <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle;">info</mat-icon>
          {{ routingValidation?.message }}
        </div>
        <div *ngIf="!routingValidating && (routingValidation?.status === 'bank_mismatch' || routingValidation?.status === 'invalid_format')"
          style="margin-top: 4px; font-size: 0.72rem; color: #b91c1c; font-weight: 600;">
          <mat-icon style="font-size: 12px; width: 12px; height: 12px; vertical-align: middle;">error_outline</mat-icon>
          {{ routingValidation?.message }}
        </div>
      </ng-container>
    </div>

    <!-- Server error (banned, 578/579, variante inválida...) -->
    <div *ngIf="serverError"
      style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; padding: 10px 12px; margin-top: 10px;">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #b91c1c; vertical-align: middle;">error_outline</mat-icon>
      <span style="color: #b91c1c; font-size: 0.8rem; font-weight: 600; margin-left: 4px;">{{ serverError }}</span>
    </div>
  </div>

  <!-- Actions -->
  <div style="display: flex; gap: 8px; border-top: 1px solid #e5e7eb; padding-top: 14px; margin-top: 14px;">
    <button type="button" (click)="cancel()" [disabled]="saving"
      style="padding: 10px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer;">
      Cancelar
    </button>
    <button type="button" (click)="save()" [disabled]="saving"
      [style.opacity]="saving ? '0.6' : '1'"
      [style.cursor]="saving ? 'not-allowed' : 'pointer'"
      style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 8px; padding: 12px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem;">
      <mat-spinner *ngIf="saving" diameter="16" style="filter: brightness(3);"></mat-spinner>
      <span *ngIf="!saving">Guardar beneficiario</span>
      <mat-icon *ngIf="!saving" style="font-size: 18px; width: 18px; height: 18px; color: white;">check</mat-icon>
    </button>
  </div>
</div>
